import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';



import 'react-tabs/style/react-tabs.css';

import { Dimmer } from '../components/spinner';

import useTable from '../components/useTableCatalogo';
import { TableBody, TableRow, TableCell, Fab } from '@mui/material'
;
import axios from 'axios';




export const CatalagoInmo2 = (props) => {

    /*  variables de estados */

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar5, setMostrar5] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const [permiso, setPermiso] = useState();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mostrar, setMostrar] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [idUsuario, setIdUsuario] = useState();
    const [declaWeb, setDeclaWeb] = useState();
    const txtIdComercio = useRef();
    const txtBuscar = useRef();
    const txtBuscarC = useRef();
    const txtDenominacionCome = useRef();
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const txtCombo = useRef();




    const cmbStatus = useRef();

    const [anio, setAnio] = useState([]);

    const headCells = [
        { id: '', label: 'RITM', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'Nº FICHA', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'NOMBRE PROPIETARIO', width: '300px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'DIRECCION', width: '300px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CODIGO CATASTRAL', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CEDULA/RIF', width: '120px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CODIGO', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
    ]

    const headCells1 = [
        { id: '', label: 'RITM', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'RIF', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'NOMBRE', width: '300px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CODIGO CATASTRAL', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CEDULA', width: '120px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: '', label: 'CODIGO', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, props.cat === 1 ? headCells : headCells1, filterFn);



    const handleSearch2 = e => {
        let target = e.target;

        if (target.name = "Search") {

            target.value = target.value.toUpperCase()

            setFilterFn({
                fn: items => {
                    if (target.value === "") {
                        return items;
                    } else {
                        let op = txtCombo.current.value;

                        return items.filter(x => {
                            if (op === 'cedula') {
                                /*  if  (x.idcomercio.toLowerCase().includes(target.value.toLowerCase())
                                || x.rif.toLowerCase().includes(target.value.toLowerCase())
                                || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
                                return x;} */
                                if (x.rif.toLowerCase().includes(target.value.toLowerCase())) {
                                    console.log('cedula')
                                    return x;
                                }
                            }
                            else if (op === 'codigo') {

                                if (x.idcomercio.toLowerCase().includes(target.value.toLowerCase())) {
                                    console.log('codigo')
                                    return x;
                                }
                            }
                            else if (op === 'nombre') {

                                if (x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
                                    console.log('nombre')
                                    return x;
                                }
                            } else {
                                return items;
                            }
                        }

                        );
                    }
                }
            })
        }



    };

    const handleSearch1 = e => {
        let target = e.target;
        target.value = target.value.toUpperCase()
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if ((x.ritm !== null ? x.ritm : '').toLowerCase().includes(target.value.toLowerCase())
                            || (x.rif !== null ? x.rif : '').toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || (x.codigocatastral !== null ? x.codigocatastral : '').toLowerCase().includes(target.value.toLowerCase())
                            || (x.reprelegal !== null ? x.reprelegal : '').toLowerCase().includes(target.value.toLowerCase())
                            || x.idcomercio.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })
        
    }

    const handleSearch = e => {
        setRecords([]);
        if (props.cat === 1) {
            if (e.which === 13 || typeof e.which === "undefined") {
                if (e.target.value !== "") {
                    seleccionarRegistrosInmueble();
                } 
            } 
        } else {
            seleccionarRegistrosComercio();
        }
        
    }




    const seleccionasrInmueble = (index) => (event) => {
        var id = recordsAfterPagingAndSorting()[index].idinmueble;
        var codicatas = recordsAfterPagingAndSorting()[index].codigocatastral;
        var direct = recordsAfterPagingAndSorting()[index].dirinmue1 + ': ' + [index].descridirinmue2 + ', ' + [index].dirinmue5 + ': ' + [index].numcivicoinmue + ', ' + [index].ciudadocupante;
        var direct2 = recordsAfterPagingAndSorting()[index].dirinmue1 + ': ' + [index].descridirinmue2 + ', ' + [index].dirinmue5 + ': ' + [index].numcivicoinmue + ', ' + [index].ciudadocupante;
        var ritm = recordsAfterPagingAndSorting()[index].ritm;
        var nombR = recordsAfterPagingAndSorting()[index].nombrepropie;
        var cedrif = recordsAfterPagingAndSorting()[index].cedulapropie;
        var areaC = recordsAfterPagingAndSorting()[index].areaconstruccion;
        var areaT = recordsAfterPagingAndSorting()[index].areaterreno;
        var usoInm = recordsAfterPagingAndSorting()[index].usoconstruccion;
        var fechAvalu = recordsAfterPagingAndSorting()[index].fechaavaluo;
        var terr = recordsAfterPagingAndSorting()[index].valorterreno;
        var constc = recordsAfterPagingAndSorting()[index].valorconstruccion;
        var valor = parseFloat(terr) + parseFloat(constc)
        var usoI = recordsAfterPagingAndSorting()[index].usoterreno;
        console.log(valor)

        blanquear();
        props.onHideAceptaCatInm(id, ritm, nombR, cedrif, areaC, areaT, usoInm, fechAvalu, codicatas, direct, direct2, valor, usoI);


    };

    const seleccionarRegistrosInmueble = () => {

        /*let campos = "ritm, numficha, nombrepropie, codigocatastral, cedulapropie, idinmueble, " +
            "(case when LOWER(dirinmue6) = quote_literal('null') OR dirinmue6 is null then quote_literal(' ') else dirinmue6 || quote_literal(' ') end ) || " +
            "(case when descridirinmue6 = quote_literal('null') OR descridirinmue6 is null then quote_literal(' ') else descridirinmue6 || quote_literal(' ') end ) || " +
            "(case when LOWER(dirinmue1) = quote_literal('null') OR dirinmue1 is null then quote_literal(' ') else dirinmue1 || quote_literal(' ') end ) || " +
            "(case when descridirinmue1 = quote_literal('null') OR descridirinmue1 is null then quote_literal(' ') else descridirinmue1 || quote_literal(' ') end ) || " +
            "(case when LOWER(dirinmue2) = quote_literal('null') OR dirinmue2 is null then quote_literal(' ')  else dirinmue2 || quote_literal(' ')  end ) || " +
            "(case when LOWER(descridirinmue2) = quote_literal('null') OR descridirinmue2 is null then quote_literal(' ')  else descridirinmue2 || quote_literal(' ') end ) || " +
            "(case when LOWER(dirinmue3) = quote_literal('null') OR dirinmue3 is null then quote_literal(' ')  else dirinmue3 || quote_literal(' ')  end ) || " +
            "(case when LOWER(descridirinmue3) = quote_literal('null') OR descridirinmue3 is null then quote_literal(' ')  else descridirinmue3 || quote_literal(' ') end ) || " +
            "(case when LOWER(dirinmue4) = quote_literal('null') OR dirinmue4 is null then quote_literal(' ')  else dirinmue4 || quote_literal(' ')  end ) || " +
            "(case when LOWER(descridirinmue4) = quote_literal('null') OR descridirinmue4 is null then quote_literal(' ')  else descridirinmue4 || quote_literal(' ') end ) || " +
            "(case when LOWER(dirinmue5) = quote_literal('null') OR dirinmue5 is null then quote_literal(' ')  else dirinmue5 || quote_literal(' ')  end ) || " +
            "(case when LOWER(descridirinmue5) = quote_literal('null') OR descridirinmue5 is null then quote_literal(' ')  else descridirinmue5 || quote_literal(' ') end ) || " +
            "(case when TRIM(LOWER(numcivicoinmue)) = quote_literal('null') OR numcivicoinmue is null OR TRIM(LOWER(numcivicoinmue)) = quote_literal('') then quote_literal('S/N') else " +
            "(case when TRIM(LOWER(numcivicoinmue)) = quote_literal('s/n') then quote_literal('S/N') else quote_literal(' N° ') || numcivicoinmue end) end ) " +
            "as direccion"*/
        let campos = "ritm, numficha, nombrepropie, codigocatastral, cedulapropie, idinmueble, TRIM(dirinmueble) as direccion"

        let nomc = txtCombo.current.value;
        let valc = txtBuscar.current.value;
        let nomtab = "inmueble";
         let orden = "idinmueble";

        let endpoint  = `${op.conexion}/api/catalogo/selecionarregistrosfiltro?campos=${campos}&nomtab=${nomtab}&nomcampo=${nomc}&valcampo=${valc}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data);
                btnCancela.current.focus();
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const seleccionarRegistrosComercio = () => {
        let campos = "ritm, rif, TRIM(nombre) AS nombre, codigocatastral, reprelegal, telefono, TRIM(direccion) AS direccion, idcomercio";
        /*let nomc = 'nombre';
        let valc = '';
        if (txtBuscar.current.value !== ''){
            nomc = txtCombo.current.value;
            valc = txtBuscar.current.value;
        } else {
            return;
        }*/
        
        let nomtab = "comercio";
        let orden = "idcomercio";

        //let endpoint  = `${op.conexion}/api/catalogo/selecionarregistrosfiltro?campos=${campos}&nomtab=${nomtab}&nomcampo=${nomc}&valcampo=${valc}&orden=${orden}`;

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;


        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const blanquear = () => {
        setItemSelect(-1)
        setActivo(true);
        setItemSelect("");
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }




    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };




    const abrirmodal = () => {
        setMostrar5(true)
    }


    const cerrarModalActualizar = () => {
        setMostrar5(false)
    }



    const salir = () => {

        props.onHideCancela();
    }



    useEffect(() => {




    }, []);

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        if (props.cat === 1) {
            var id = recordsAfterPagingAndSorting()[index].idinmueble;
            var codicatas = recordsAfterPagingAndSorting()[index].codigocatastral;
            //var direct = recordsAfterPagingAndSorting()[index].dirinmue1 + ': ' + recordsAfterPagingAndSorting()[index].descridirinmue2 + ', ' + recordsAfterPagingAndSorting()[index].dirinmue5 + ': ' + recordsAfterPagingAndSorting()[index].numcivicoinmue + ', ' + recordsAfterPagingAndSorting()[index].ciudadocupante;
            var direct = recordsAfterPagingAndSorting()[index].direccion;
            var direct2 = recordsAfterPagingAndSorting()[index].dirinmue1 + ': ' + recordsAfterPagingAndSorting()[index].descridirinmue2 + ', ' + recordsAfterPagingAndSorting()[index].dirinmue5 + ': ' + recordsAfterPagingAndSorting()[index].numcivicoinmue + ', ' + recordsAfterPagingAndSorting()[index].ciudadocupante;
            var ritm = recordsAfterPagingAndSorting()[index].ritm;
            var nombR = recordsAfterPagingAndSorting()[index].nombrepropie;
            var cedrif = recordsAfterPagingAndSorting()[index].cedulapropie;
            var areaC = recordsAfterPagingAndSorting()[index].areaconstruccion;
            var areaT = recordsAfterPagingAndSorting()[index].areaterreno;
            var usoInm = recordsAfterPagingAndSorting()[index].usoconstruccion;
            var fechAvalu = recordsAfterPagingAndSorting()[index].fechaavaluo;
            var terr = recordsAfterPagingAndSorting()[index].valorterreno;
            var constc = recordsAfterPagingAndSorting()[index].valorconstruccion;
            var valor = parseFloat(terr) + parseFloat(constc)
            var usoI = recordsAfterPagingAndSorting()[index].usoterreno;
            var tlf = '';

            setValues({ id, ritm, nombR, cedrif, areaC, areaT, usoInm, fechAvalu, codicatas, direct, direct2, valor, usoI, tlf });


        } else {

            var id = recordsAfterPagingAndSorting()[index].idcomercio;
            var codicatas = recordsAfterPagingAndSorting()[index].codigocatastral;
            var direct = recordsAfterPagingAndSorting()[index].direccion;
            var direct2 = recordsAfterPagingAndSorting()[index].direccion;
            var ritm = recordsAfterPagingAndSorting()[index].ritm;
            var nombR = recordsAfterPagingAndSorting()[index].nombre;
            var cedrif = recordsAfterPagingAndSorting()[index].rif;
            var tlf = recordsAfterPagingAndSorting()[index].telefono;
            var areaC = 0;
            var areaT = 0;
            var usoInm = 0;
            var fechAvalu = 0;
            var terr = 0;
            var constc = 0;
            var valor = 0;
            var usoI = 0;

            setValues({ id, ritm, nombR, cedrif, areaC, areaT, usoInm, fechAvalu, codicatas, direct, direct2, valor, usoI, tlf });


            console.log(recordsAfterPagingAndSorting()[index])
        }

    };

    const selectOrden = () => {


        blanquear();
        console.log(values)
        props.onHideAceptaCatInm(values.id, values.ritm, values.nombR, values.cedrif, values.areaC, values.areaT, values.usoInm, values.fechAvalu, values.codicatas, values.direct, values.direct2, values.valor, values.usoI, values.tlf);


    };


    const seleccionasrComercio = (index) => (event) => {

        var id = recordsAfterPagingAndSorting()[index].idcomercio;
        var direct = recordsAfterPagingAndSorting()[index].direccion;
        var nombR = recordsAfterPagingAndSorting()[index].nombre;
        var cedrif = recordsAfterPagingAndSorting()[index].rif;
        var tlf = recordsAfterPagingAndSorting()[index].telefono;
        var direct2 = recordsAfterPagingAndSorting()[index].direccion;
        var actP = recordsAfterPagingAndSorting()[index].tipoactividad
        blanquear();
        props.onHIdeAceptaCaCom(id, direct, nombR, cedrif, tlf, direct2, actP);


    };

    const onChange = () => {
        txtBuscar.current.value = '';
        setRecords([]);
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

                console.log(props.cat)
                if (props.cat === 1) {
                    //seleccionarRegistrosInmueble()
                    console.log('consulta inmueble lista')
                } else if (props.cat === 0) {
                    seleccionarRegistrosComercio()
                    console.log('consulta comercio lista')

                }

            }}

        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Buscar</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={salir}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>

              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div >

                    <div className="card-body">
                        <div className="content" >
                            <div className="container">

                                <div className="row">
                                    {props.cat === 1 ?
                                        <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-12 m-0 p-0">

                                                    <div className="input-group input-group-sm mb-3 m-0 col-md-7">
                                                        <select
                                                            name="idclasevehiculo"
                                                            ref={txtCombo}
                                                            onChange={onChange}
                                                            className="form-select col-md-6 form-control-sm"
                                                            id="inputTP"

                                                        >
                                                            <option value='ritm'>RITM</option>
                                                            <option value='numficha'>Nº Ficha</option>
                                                            <option value='nombrepropie'>Nombre Propietario</option>
                                                            <option value='direccion'>Dirección </option>
                                                            <option value='codigocatastral'>Código Catastral </option>
                                                            <option value='cedulapropie'>Cedula Propietario</option>
                                                            <option value='idinmueble'>Código</option>
                                                        </select>
                                                        <input type='text' ref={txtBuscar} className="form-control form-control-sm " onKeyUp={handleSearch} onBlur={handleSearch}/>
                                                        {/*<input type='text' onChange={handleSearch1} className="form-control rounded-pill" />*/}
                                                    </div>
                                                </div>
                                                <div className="col-md-12" >
                                                    <TblContainer >
                                                        <TblHead />

                                                        <tbody>
                                                            {

                                                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                                                    <tr key={item.idinmueble} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.ritm}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.numficha}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.nombrepropie}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.direccion}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.codigocatastral}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.cedulapropie}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idinmueble}</td>
                                                                        {/* <td style={{ fontSize: "10px", textAlign: "center", padding: 0 }}>
                                                                        <button style={{ fontSize: '10px' onClick={seleccionasrInmueble(index)} className="btn btn-outline-info"><i className="fas fa-search">Seleccionar</i> </button>
  
                                                                  </td> */}
                                                                    </tr>

                                                                ))
                                                            }
                                                        </tbody>
                                                    </TblContainer>
                                                    <TblPagination />
                                                </div>
                                            </div>
                                        </div>
                                        : ''}

                                    {props.cat === 0 ?
                                        <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                            <div className="row">
                                                <div className="col-md-12 m-0 p-0">

                                                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                                                        {/*<select
                                                            name="idclasevehiculo"
                                                            ref={txtCombo}
                                                            onChange={onChange}
                                                            className="form-select col-md-6 form-control-sm"
                                                            id="inputTP"

                                                        >
                                                            <option value='ritm'>RITM</option>
                                                            <option value='rif'>Rif</option>
                                                            <option value='nombre'>Nombre</option>
                                                            <option value='codigocatastral'>Código Catastral </option>
                                                            <option value='reprelegal'>Cedula</option>
                                                            <option value='idcomercio'>Código</option>
                                                        </select>
                                                        <input type='text' ref={txtBuscar} className="form-control form-control-sm " onKeyUp={handleSearch} />*/}
                                                        <input type='text' onChange={handleSearch1} className="form-control rounded-pill" placeholder="Buscar" />
                                                    </div>
                                                </div>


                                                <div className="col-md-12" >
                                                    <TblContainer >
                                                        <TblHead />

                                                        <tbody>
                                                            {
                                                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                                                    <tr key={item.numcontrato} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.ritm}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.rif}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.nombre}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.codigocatastral}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.reprelegal}</td>
                                                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idcomercio}</td>
                                                                    </tr>

                                                                ))
                                                            }
                                                        </tbody>

                                                    </TblContainer>
                                                    <TblPagination />
                                                </div>
                                            </div>
                                        </div>

                                        : ''}

                                </div>
                            </div>
                        </div>

                        <div className="row">
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer >
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectOrden}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={salir} className="btn btn-danger btn-sm rounded-pill col-md-2 "><i className="fas fa-window-close">Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}